import { action } from 'typesafe-actions';

import { SET_MERCHANTS_AND_OFFERS_RS, SET_MERCHANTS_AND_OFFERS_RS_LOADED } from './constants';
import { MerchantAndOffersRS } from '../../types/merchant';

export const setMerchantsAndOffersRS = (merchants: MerchantAndOffersRS[]) =>
  action(SET_MERCHANTS_AND_OFFERS_RS, merchants);

export const setMerchantsAndOffersRSLoaded = (data: { ids: string[]; loaded?: boolean; remove?: boolean }) =>
  action(SET_MERCHANTS_AND_OFFERS_RS_LOADED, data);
